module.exports = __webpack_public_path__ + "static/media/work-1.44c24dd7.jpg";